import ClarityMicrosoft from '@microsoft/clarity'

import { APP_CLARITY_ID } from 'src/config'

class ClarityPlugin {
  init(): void {
    if (APP_CLARITY_ID) {
      ClarityMicrosoft.init(APP_CLARITY_ID)
    }
  }

  consent(): void {
    ClarityMicrosoft.consent()
  }
}

export default ClarityPlugin
